import { AuthedPageProviders } from '@/components/AuthedPageContext';
import AuthPageWrapper from '@/components/AuthPageWrapper';
import { PageContextProvider } from '@/components/common/pageLayout/PageContext';
import DashboardPage from '@/components/dashboard/DashboardPage';
import ExportPage from '@/components/export/ExportPage';
import { FinancialEntitiesProvider } from '@/components/financialEntities/FinancialEntitiesProvider';
import { useCurrentUser } from '@common/react/user';
import type { NextPage } from 'next';

const HomePageWrapper: NextPage = () => {
    return (
        <AuthPageWrapper>
            <HomePage />
        </AuthPageWrapper>
    );
};

const HomePage = () => {
    const { featureFlags } = useCurrentUser();

    return featureFlags.isShutdownV1Enabled ? (
        <PageContextProvider>
            <FinancialEntitiesProvider>
                <AuthedPageProviders>
                    <ExportPage />
                </AuthedPageProviders>
            </FinancialEntitiesProvider>
        </PageContextProvider>
    ) : (
        <DashboardPage />
    );
};

export default HomePageWrapper;
